import React from "react";
import Styles from './styles.module.scss';

import brushBuy from '../../../theme/assets/redesign/brush_buy.svg';
import brushSell from '../../../theme/assets/redesign/brush_sell.svg';
import arrowIcon from '../../../theme/assets/redesign/btn_arrow.svg';


// variant: 'primary' (красная кисть — Buy) | 'positive' (зелёная кисть — Sell)
const BrushButton = ({variant = 'primary', disabled, onClick, children, className, noArrow, brush}) => (
    <button
        type="button"
        className={`${Styles.button} ${Styles[variant]} ${disabled ? Styles.disabled : ''} ${className || ''}`}
        onClick={onClick}
    >
        <img className={Styles.brush} src={brush || (variant === 'positive' ? brushSell : brushBuy)} alt=""/>
        <span>{children}</span>
        {noArrow ? null : <img className={Styles.arrow} src={arrowIcon} alt="" width="18" height="18"/>}
    </button>
);

export default BrushButton;
